import React from 'react';
import { useDroppable } from './KanbanDndContext';
import { Trash2, Check } from 'lucide-react';

interface DeleteDropZoneProps {
  activeDragId: string | number | null;
  droppedZoneId?: string | null;
  isReadOnly?: boolean;
}

export const DeleteDropZone: React.FC<DeleteDropZoneProps> = ({ 
  activeDragId, 
  droppedZoneId,
  isReadOnly = false
}) => {
  const { setNodeRef, isOver } = useDroppable({
    id: 'action-delete',
    disabled: isReadOnly,
  });

  const isActiveDrag = activeDragId !== null;
  const isDropped = droppedZoneId === 'action-delete';

  if (isReadOnly) return null;

  return (
    <div
      ref={setNodeRef}
      data-dropzone="action-delete"
      data-dropzone-over={isOver ? 'true' : 'false'}
      role="region"
      aria-label="Aufgabe hierher ziehen zum Löschen"
      className="p-3 -m-3"
    >
      <div
        className={`
          flex items-center gap-2 rounded-xl transition-all duration-300 ease-out select-none border
          ${isActiveDrag ? 'cursor-grabbing' : 'cursor-default'}
          ${isActiveDrag 
            ? 'px-6 py-3.5 border-dashed border-rose-400/40 dark:border-rose-500/40 bg-rose-50/30 dark:bg-rose-950/20 scale-105 shadow-sm' 
            : 'px-4 py-2 border-transparent bg-transparent hover:bg-rose-50/30 dark:hover:bg-rose-950/20 hover:border-rose-300/40 dark:hover:border-rose-800/40'}
          ${isOver 
            ? '!bg-rose-100 dark:!bg-rose-900/60 scale-120 !border-rose-500 shadow-[0_0_20px_rgba(244,63,94,0.4)] z-20' 
            : ''}
          ${isDropped 
            ? '!bg-rose-600 !border-rose-600 text-white scale-110 shadow-lg shadow-rose-600/20 z-10 animate-pulse' 
            : ''}
        `}
      >
        <div className={`transition-colors duration-200 ${isDropped ? 'text-white' : 'text-rose-500'}`}>
          {isDropped ? (
            <Check size={isActiveDrag ? 15 : 14} className="stroke-[3] text-white" />
          ) : (
            <Trash2 size={isActiveDrag ? 15 : 13} strokeWidth={2.5} />
          )}
        </div>
        <span className={`
          font-black uppercase tracking-wider transition-all duration-300
          ${isActiveDrag ? 'text-xs' : 'text-[10px]'}
          ${isDropped ? 'text-white' : isOver ? 'text-rose-600 dark:text-rose-300' : 'text-slate-400'}
        `}>
          {isDropped ? 'Gelöscht' : isOver ? 'Loslassen: Löschen' : 'Löschen'}
        </span>
      </div>
    </div>
  );
};
